import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { sk } from '@/utils/stableKey';

/**
 * Visual breadcrumb navigation for ACRES.
 * 
 * @param {Array} items - Array of { name, url } objects. Last item has no url (current page).
 * @param {string} variant - 'dark' (on green hero) or 'light' (on ivory background)
 */
const Breadcrumbs = ({ items = [], variant = 'dark' }) => {
  if (!items.length) return null;

  const isDark = variant === 'dark';

  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className="flex items-center gap-1.5 text-sm flex-wrap mb-6"
    >
      <Link
        to="/"
        data-testid="breadcrumb-home"
        className={`transition-colors ${
          isDark
            ? 'text-[#C4A36B]/50 hover:text-[#C4A36B]'
            : 'text-[#042E0C]/40 hover:text-[#042E0C]'
        }`}
      >
        <Home size={14} />
      </Link>
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={sk(item, i)} className="flex items-center gap-1.5">
            <ChevronRight
              size={12}
              className={isDark ? 'text-[#C4A36B]/30' : 'text-[#042E0C]/20'}
            />
            {isLast || !item.url ? (
              <span
                data-testid={`breadcrumb-${i}`}
                className={`font-medium tracking-wide ${
                  isDark ? 'text-[#C4A36B]' : 'text-[#042E0C]'
                }`}
              >
                {item.name}
              </span>
            ) : (
              <Link
                to={item.url}
                data-testid={`breadcrumb-${i}`}
                className={`tracking-wide transition-colors ${
                  isDark
                    ? 'text-[#C4A36B]/50 hover:text-[#C4A36B]'
                    : 'text-[#042E0C]/40 hover:text-[#042E0C]'
                }`}
              >
                {item.name}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
